module.exports = __webpack_public_path__ + "static/img/conveyor-lift-mk-1_256.76d425f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-lift-mk-1_256.png
// module id = 4UQK
// module chunks = 0